import { render, staticRenderFns } from "./examSeatModal.vue?vue&type=template&id=3581632d&scoped=true"
import script from "./examSeatModal.vue?vue&type=script&lang=js"
export * from "./examSeatModal.vue?vue&type=script&lang=js"
import style0 from "./examSeatModal.vue?vue&type=style&index=0&id=3581632d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3581632d",
  null
  
)

export default component.exports